/* eslint-disable prefer-regex-literals */ export const sensitivePatterns = [
    {
        name: 'JWT',
        regex: new RegExp('eyJ[A-Za-z0-9-_]+\\.[A-Za-z0-9-_]+\\.[A-Za-z0-9-_]+', 'g')
    },
    {
        name: 'JWTPartial',
        regex: new RegExp('eyJ[a-z0-9\\-_%]+\\.eyJ[a-z0-9\\-_%]+', 'gi')
    },
    {
        name: 'URLWithCredentials',
        regex: new RegExp('((amqp|ssh|(ht|f)tps?)://[^%:\\s"\'/][^:\\s"\'/\\$]+[^:\\s"\'/\\$%]:([^%\\s"\'/][^@\\s"\'/]{0,100}[^%\\s"\'/])@[\\$a-z0-9:\\._%\\?=/]+|[a-z0-9]{3,5}://[^%:\\s"\'/][^:\\s"\'/\\$]+[^:\\s"\'/\\$%]:([^%\\s"\'/][^@\\s"\'/]{0,100}[^%\\s"\'/])@[\\$a-z0-9:\\._%\\?=/-]+)', 'gi')
    },
    {
        name: 'PasswordParameters',
        regex: new RegExp('(password|pass)=([^&\\s"\']+)', 'gi')
    },
    {
        name: 'StorageAccountKey',
        regex: new RegExp('([?&]sig)=([^&\\s"\']+)', 'gi')
    }
];
export function scrubSensitiveData(envelope, visited = new WeakSet()) {
    if (!envelope || typeof envelope !== 'object') return;
    // Check if we've already visited this object
    if (visited.has(envelope)) return;
    // Mark this object as visited
    visited.add(envelope);
    for(const key in envelope){
        const value = envelope[`${key}`];
        if (typeof value === 'string') {
            for (const pattern of sensitivePatterns){
                envelope[`${key}`] = envelope[`${key}`].replace(pattern.regex, 'SCRUBBED');
            }
        } else if (typeof value === 'object') {
            scrubSensitiveData(value, visited);
        }
    }
}
export function scrubField(value) {
    if (typeof value !== 'string') return value;
    let result = value;
    for (const pattern of sensitivePatterns){
        result = result.replace(pattern.regex, 'SCRUBBED');
    }
    return result;
}
